import { GlIcon, GlLink, GlTooltip } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ListItemStat',
    components: {
        GlIcon,
        GlTooltip
    },
    props: {
        tooltipText: {
            type: String,
            required: false,
            default: null
        },
        a11yText: {
            type: String,
            required: false,
            default: null
        },
        iconName: {
            type: String,
            required: true
        },
        stat: {
            type: [
                String,
                Number
            ],
            required: true
        },
        href: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'click',
        'hover'
    ],
    computed: {
        component () {
            return this.href ? GlLink : 'div';
        },
        tooltipTargetEl () {
            return this.href ? this.$refs?.stat?.$el : this.$refs?.stat;
        }
    },
    methods: {
        onTooltipShown () {
            this.$emit('hover');
        },
        onClick () {
            if (!this.href) {
                return;
            }
            this.$emit('click');
        }
    }
};
